import React, { useEffect, useState } from "react";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { useSelector } from "react-redux";
export default function Welcome() {
  const jsonFile = useSelector((state: any) => state.style);
  return (
    <div
      className="classCenter "
      style={{ marginTop: "5vh", width: "80%", height: "80%" }}
    >
      <img
        style={{
          width: "25%",
          margin: "auto",
          marginTop: ".2vh",
          objectFit: "contain",
        }}
        src="images/welcome.png"
      />
      <br />
      <br />
      <div>
        <b
          style={{
            textAlign: "center",
            fontSize: "2em",
            color: "#00253D",
            marginTop: "5vh",
            width: "50%",
          }}
        >
          پذیرنده محترم
        </b>
      </div>
      <div className="mTop20">
        <b
          style={{
            textAlign: "center",
            fontSize: "2em",
            color: "#00253D",
            marginTop: "5vh",
            width: "50%",
          }}
        >
          به سامانه پذیرندگان شرکت
          <span style={{ color: jsonFile?.mainColor }}>
            {" "}
            {jsonFile?.companyName}{" "}
          </span>{" "}
          خوش آمدید.
        </b>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: jsonFile?.welcomePageContent }}
      ></div>
    </div>
  );
}
